// Community-poll limits shared by the worker (validation) and the React app
// (form UX), so the two never drift.

export const POLL_MIN_OPTIONS = 2;
export const POLL_MAX_OPTIONS = 6;
export const POLL_QUESTION_MAX = 200;
export const POLL_OPTION_MAX = 80;

// A poll's optional minimum-voter-level gate. WarEra levels start at 1 and the
// forecast model caps its level factor at 100, so that's the usable range.
export const POLL_LEVEL_MIN = 1;
export const POLL_LEVEL_MAX = 100;

// A poll's optional closing time. Anonymous creators must pick one; verified
// creators may leave it open and close on demand. Presets are offered in the
// form (in days); a custom datetime is also allowed, bounded by the max.
const DAY_MS = 24 * 60 * 60 * 1000;
export const POLL_DURATION_PRESET_DAYS = [1, 3, 7, 14] as const;
export const POLL_MAX_DURATION_MS = 60 * DAY_MS; // a close time can't be further out than this
